import PropTypes from 'prop-types'
import { Alert, Typography } from '@mui/material'

import { ReactComponent as CalendarBlank } from '../../../../assets/icons/calendar-blank.svg'
import { ReactComponent as ErrorIcon } from '../../../../assets/icons/warning.svg'
import useTranslations from '../../../../i18n/useTranslations'
import { formatPickupId } from './ChoosePickup'

import styles from './styles'

const propTypes = {
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  pickupDate: PropTypes.string,
  errorMessage: PropTypes.string,
}

const Asap = ({ isError, isLoading, pickupDate, errorMessage }) => {
  const formatMessage = useTranslations()

  if (isError) {
    return (
      <Alert
        severity="error"
        icon={<ErrorIcon />}
        sx={{ ...styles.alert, ...styles.alertEarlyDate }}
      >
        <Typography variant="body2">
          {errorMessage ??
            formatMessage('shipping-send-form:origin:pickup-not-available')}
        </Typography>
      </Alert>
    )
  }

  if (isLoading) {
    return (
      <Alert severity="info" sx={{ ...styles.alert, ...styles.alertEarlyDate }}>
        <Typography variant="h3medium">
          {formatMessage('message:loading')}
        </Typography>
      </Alert>
    )
  }
  return (
    <Alert
      severity="success"
      icon={<CalendarBlank />}
      sx={{ ...styles.alert, ...styles.alertEarlyDate }}
    >
      <Typography variant="h3medium">
        {pickupDate !== null
          ? formatMessage(
              'shipping-send-form:pickup-date',
              formatPickupId(pickupDate),
            )
          : null}
      </Typography>
    </Alert>
  )
}

Asap.propTypes = propTypes

export default Asap
